<template>
  <v-container fluid>
    <div v-if="isLoggedIn">
      <v-layout>
        <v-flex xs3 offset-xs6 pr-4>
          <v-autocomplete
            v-model="selectedLoanProductId"
            :items="loanProducts"
            item-text="product_title"
            item-value="id"
            label="Loan Product"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs3>
          <UploadExcelDialog :apiUrl="apiUrl" @success="reloadFunding" />
        </v-flex>
      </v-layout>
      <v-tabs
        v-model="active"
        color="indigo"
        centered
        dark
        slider-color="yellow"
      >
        <v-tab
          v-for="(status, index) in statuses"
          :key="index"
          ripple
          @click="next(status.status_id)"
        >
          {{ status.title }}
        </v-tab>
        <v-tab-item
          v-for="(status, index) in statuses"
          :key="index"
          class="fundingList"
        >
          <v-card flat v-if="statusId == status.status_id">
            <FundingByStatus
              :loanProductId="selectedLoanProductId"
              :status="statusId"
              :dateTitle="status.dateTitle"
              :search="search"
              :page="page"
              :rowsPerPage="rowsPerPage"
              :scroll="scroll"
              :reload="reload"
              @goto="goToUrl"
              @reloadCompleted="reload = false"
            />
          </v-card>
        </v-tab-item>
      </v-tabs>
    </div>
    <div centered v-else>
      <v-container>
        <v-layout row wrap>
          <v-flex xs4 md4></v-flex>
          <v-flex xs4 md4 align-end>
            <v-card>
              <v-card-text color="white">You are not logged in!</v-card-text>
            </v-card>
            <router-link to="/signin">
              <v-btn color="indigo">
                <v-icon>lock_open</v-icon>
                login
              </v-btn>
            </router-link>
          </v-flex>
          <v-flex xs4 md4></v-flex>
        </v-layout>
      </v-container>
    </div>
  </v-container>
</template>

<script>
  import FundingByStatus from "@/components/FundingByStatus";

  import { mapGetters } from "vuex";
  import HTTP from "@/utils/HTTP";
  import {
    loanProductsUrl,
    uploadLoanApplicationsExcelUrl,
  } from "@/utils/variables";
  import UploadExcelDialog from "@/components/Dialogs/UploadExcelDialog";

  export default {
    components: {
      UploadExcelDialog,
      FundingByStatus,
    },
    data() {
      return {
        dialog: false,
        active: null,
        selectedLoanProductId: 0,
        loanProducts: [],
        apiUrl: uploadLoanApplicationsExcelUrl,
        statuses: [
          { title: "Pending", dateTitle: "Applied on", status_id: 1 },
          { title: "Verified", dateTitle: "Verified on", status_id: 2 },
          { title: "Rejected", dateTitle: "Rejected on", status_id: 3 },
          { title: "Processing", dateTitle: "Processed on", status_id: 4 },
          {
            title: "Signed by Investor",
            dateTitle: "Signed by Investor on",
            status_id: 5,
          },
          {
            title: "Signed by Investee",
            dateTitle: "Signed by Investee on",
            status_id: 6,
          },
          { title: "Approved", dateTitle: "Approved on", status_id: 7 },
          { title: "Disbursed", dateTitle: "Disbursed on", status_id: 8 },
          { title: "Completed", dateTitle: "Completed on", status_id: 9 },
          { title: "Cancelled", dateTitle: "Cancelled on", status_id: 10 },
          { title: "Defaulted", dateTitle: "Defaulted on", status_id: 11 },
        ],
        statusId: 1,
        search: "",
        page: 0,
        rowsPerPage: 0,
        scroll: 0,
        reload: false,
      };
    },
    computed: {
      // ...mapState({
      //   fundingStatusId: (state) => state.application.fundingStatusId,
      // }),
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
        "investorAgreement",
        "investeeAgreement",
        "userImage",
        "docImage",
        "shadhinFundingLoanProductId",
        "backRouteActive",
      ]),
    },

    async created() {
      this.backRouteActive ? await this.setParams() : "";
      await this.getLoanProducts();

      // await this.fundingList();
    },

    watch: {
      // selectedLoanProductId() {
      //   this.filterByLoanProductId(this.selectedLoanProductId);
      // },
      shadhinFundingLoanProductId() {
        this.selectedLoanProductId = this.shadhinFundingLoanProductId;
      },
    },

    methods: {
      async setParams() {
        this.$route.query.productId
          ? (this.selectedLoanProductId = parseInt(this.$route.query.productId))
          : (this.selectedLoanProductId = 0);

        this.$route.query.statusId
          ? (this.statusId = this.$route.query.statusId)
          : (this.statusId = 1);
        this.$route.query.statusId
          ? (this.active = this.$route.query.statusId - 1)
          : (this.active = 0);
        this.$route.query.search
          ? (this.search = this.$route.query.search)
          : "";
        this.$route.query.page
          ? (this.page = this.$route.query.page)
          : (this.page = 0);
        this.$route.query.rowsPerPage
          ? (this.rowsPerPage = this.$route.query.rowsPerPage)
          : (this.rowsPerPage = 0);
        this.$route.query.scroll
          ? (this.scroll = this.$route.query.scroll)
          : "";
      },
      next(status) {
        // const active = parseInt(this.active)
        // console.log(status)
        this.statusId = status;
        this.$store.commit("setFundingStatusId", status);
        // this.fundingList(status);
        this.active = this.active < 10 ? this.active + 1 : 0;
      },

      async getLoanProducts() {
        const { data } = await HTTP().get(loanProductsUrl);
        this.loanProducts = data.data;
        this.loanProducts.forEach((product) => {
          product.product_title = `${
            product.product_title
          } (${product.product_title
            .split(/\s/)
            .reduce((response, word) => (response += word.slice(0, 1)), "")
            .toUpperCase()})`;
        });
        this.loanProducts.unshift({
          id: 0,
          product_title: "All",
        });
      },

      // async fundingList(statusId = this.statusId) {
      //   await this.$store.dispatch("getFundingList", [
      //     "funding-list",
      //     statusId,
      //     this.search,
      //     this.page,
      //     this.rowsPerPage,
      //   ]);
      // },

      // filterByLoanProductId: function (loanProductId) {
      //   this.$store.commit("setLoanProductId", loanProductId);
      //   // this.fundingList(this.statusId);
      // },

      goToUrl({ goUrl, backUrl }) {
        const fullUrl = `${backUrl}&productId=${this.selectedLoanProductId}&statusId=${this.statusId}`;
        this.$store.commit("setGoBackRoute", fullUrl);
        this.$router.push(goUrl);
      },

      reloadFunding() {
        this.setParams();
        this.reload = true;
      },
    },
  };
</script>

<style>
  ul.v-pagination {
    padding: 20px;
  }
  .theme--light.v-table thead th {
    color: rgba(0, 0, 0, 0.7);
    font-size: 13px;
  }
  .fundingList table.v-table thead th {
    padding: 0 1px !important;
    text-align: center !important;
  }
  .fundingList table.v-table tbody td {
    padding: 0 3px !important;
    text-align: center;
  }
</style>
